/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Studio_Output_EmptyInputs */

const en_landing_studio_output_empty = /** @type {(inputs: Landing_Studio_Output_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your image will appear here.`)
};

const zh_landing_studio_output_empty = /** @type {(inputs: Landing_Studio_Output_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成的图片会显示在这里。`)
};

/**
* | output |
* | --- |
* | "Your image will appear here." |
*
* @param {Landing_Studio_Output_EmptyInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const landing_studio_output_empty = /** @type {((inputs?: Landing_Studio_Output_EmptyInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Studio_Output_EmptyInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_landing_studio_output_empty(inputs)
	return zh_landing_studio_output_empty(inputs)
});
export { landing_studio_output_empty as "landing.studio.output_empty" }